//
//	Handle rendering of header, basicly for switches between mobile and desktop
//
import React from 'react';
import { connect } from "react-redux";

//	This maps the data store to local variables.
const mapStateToProps = state  => {
	return {
		firstLoad: state.firstLoad
	};
};

class Footer extends React.Component {

	constructor(props) {

		super(props);
		
	}

	componentDidMount() {

		// temp commented to work with only getting current user..
		//setUsers( this.props );
		
		//firstLoad
		this.props.dispatch({type: 'COMPLETE_SERVER_LOAD'});
		


	}
	render() {
		return(
			<div className="App-footer">
				<p className="App-intro"></p>
			</div>
		);
		
	}
}

export default connect(mapStateToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/parts/Footer.js